
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/lib/theme-chalk/index.css'
// import 'dayjs/locale/zh-cn'
// import locale from 'element-plus/lib/locale/lang/zh-cn'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import "lib-flexible-computer"

import LemonIMUI from 'lemon-imui';
import 'lemon-imui/dist/index.css';

// require styles 引入样式
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"

import "../public/migrate.js"

// 分环境处理

String.prototype.PadLeft = function(len, charStr) {
	var s = this + '';
	return new Array(len - s.length + 1).join(charStr || '') + s;
}
String.prototype.PadRight = function(len, charStr) {
	var s = this + '';
	return s + new Array(len - s.length + 1).join(charStr || '');
}



NProgress.configure({

	easing: 'easy', // 动画方式

	speed: 500, // 递增进度条的速度

	showSpinner: false, // 是否显示加载ico

	trickleSpeed: 200, // 自动递增间隔

	minimum: 0.3 // 初始化时的最小百分比

})

const app=createApp(App)
// Vue3 全局挂载系统名称1.203.114.210:8007/
// app.config.globalProperties.$websocket = new WebSocket("ws://wechatapi.shooinsupport.com:6080/ws");
// app.config.globalProperties.$websocket = new WebSocket("ws://192.168.1.20:8007/ws");
let ws=null;
app.config.globalProperties.$websocket = ()=>{
	if(ws){
		return ws
	}else{
		// ws=new WebSocket("ws://wechatapi.shooinsupport.com:6080/ws")
		// ws=new WebSocket("ws://172.16.100.33:8007/ws") //33
		// ws=new WebSocket("ws://192.168.1.66:8001/ws") //本地
		ws=new WebSocket(infoUrl) //本地
		return ws
	}
};
// var wstelephone =null
// app.config.globalProperties.$websocketTelePhone = ()=>{
// 	if(wstelephone){
// 		return wstelephone
// 	}else{
// 		wstelephone = new WebSocket('ws://192.168.1.66:10730/ws');
// 		// wstelephone = new WebSocket('wss://wechat.shooinsupport.com:10730/ws');
// 		return wstelephone
// 	}
// };


// app.config.globalProperties.$webtel = ()=>{
// 	if(telephone){
// 		return telephone
// 	}else{
// 		telephone=new WebSocket("ws://192.168.1.66:10730/ws")
// 		return telephone
// 	}
	// return new WebSocket("ws://192.168.1.20:8007/ws")

// app.config.globalProperties.$websocket = new WebSocket("ws://192.168.1.160:8001/ws");
// app.config.globalProperties.$websocket = new WebSocket(`ws://${socketURL}/ws`);
app.use(ElementPlus,{/*locale8*/}).use(store).use(router).use(LemonIMUI).mount('#app')
export default app
